/* @flow */
import type { Action } from 'action';

export type Status = 'online' | 'offline';
export type State = {status: Status};

export const initialState: State = {
  status: 'offline',
};

// typecheck: ignore statement
export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'zopim/CHANGE_STATUS':
      return { ...state, status: action.status };
    default:
      return state;
  }
}

type changeStatusAction = {
  type: 'zopim/CHANGE_STATUS',
  status: Status,
};

export function changeStatus(status: Status): changeStatusAction {
  return {
    type: 'zopim/CHANGE_STATUS',
    status,
  };
}

export type ZopimAction = changeStatusAction;



// WEBPACK FOOTER //
// ./src/reducers/zopim.js